/**
 * Supabase Client for authentication.
 *
 * This client is used for Supabase Auth features.
 * For REST API calls, use service files with apiClient.
 */

import { createClient, SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://dmnlzmtkykvhdbjiylmb.supabase.co';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// Singleton Supabase client - initialized once at module level
// Using direct initialization instead of lazy loading to ensure single instance
const supabaseClient: SupabaseClient = (() => {
  if (!SUPABASE_ANON_KEY) {
    console.warn('VITE_SUPABASE_ANON_KEY not set');
  }
  return createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  });
})();

/**
 * Get the singleton Supabase client instance.
 * This ensures only one GoTrueClient instance exists in the browser context.
 */
export function getSupabaseClient(): SupabaseClient {
  return supabaseClient;
}

// Export the singleton instance directly
export const supabase = supabaseClient;
